<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>
    <ng-container *ngIf="consulta">
        <div class="body px-2">

            <ng-container *ngFor="let r of consulta?.registros?.socios; let i = index">
                <h2 class="subtitle">SÓCIO {{i+1}}</h2>
                <div class="row">
                    <div class="col-12 col-md-12 col-lg-12 col-print-12">
                        <div class="d-flex d-print-flex py-2">
                            <div class="row col-12 px-2 mb-4">
                                <div class="d-flex justify-content-between p-0 col-12 d-sm-inline-block col-sm-4 py-sm-2 p-sm-0 col-print-7 
                                            d-md-inline-block col-md-4 py-md-2 p-md-0 d-lg-inline-block col-lg-4 py-lg-2 p-lg-0">
                                    <div class="text-secondary format-compacta">DOCUMENTO:</div>
                                    <div class="text-uppercase format-compacta">{{ r?.documento || msgNull }}</div>
                                </div>
                                <div class="d-flex justify-content-between p-0 col-12 d-sm-inline-block col-sm-4 py-sm-2 p-sm-0 col-print-7 
                                            d-md-inline-block col-md-4 py-md-2 p-md-0 d-lg-inline-block col-lg-4 py-lg-2 p-lg-0">
                                    <div class="text-secondary format-compacta">CPF:</div>
                                    <div class="text-uppercase format-compacta">{{ r?.cpf || msgNull }}</div>
                                </div>
                                <div class="d-flex justify-content-between p-0 col-12 d-sm-inline-block col-sm-4 py-sm-2 p-sm-0 col-print-7 
                                            d-md-inline-block col-md-4 py-md-2 p-md-0 d-lg-inline-block col-lg-4 py-lg-2 p-lg-0">
                                    <div class="text-secondary format-compacta">NOME:</div>
                                    <div class="text-uppercase format-compacta">{{ r?.nome || msgNull }}</div>
                                </div>
                                <div class="d-flex justify-content-between p-0 col-12 d-sm-inline-block col-sm-4 py-sm-2 p-sm-0 col-print-7 
                                            d-md-inline-block col-md-4 py-md-2 p-md-0 d-lg-inline-block col-lg-4 py-lg-2 p-lg-0">
                                    <div class="text-secondary format-compacta">ELEITO EM:</div>
                                    <div class="text-uppercase format-compacta">{{ r?.eleitoEm || msgNull }}</div>
                                </div>
                                <div class="d-flex justify-content-between p-0 col-12 d-sm-inline-block col-sm-4 py-sm-2 p-sm-0 col-print-7 
                                            d-md-inline-block col-md-4 py-md-2 p-md-0 d-lg-inline-block col-lg-4 py-lg-2 p-lg-0">
                                    <div class="text-secondary format-compacta">ELEITO ATÉ:</div>
                                    <div class="text-uppercase format-compacta">{{ r?.eleitoAte || msgNull }}</div>
                                </div>
                                <div class="d-flex justify-content-between p-0 col-12 d-sm-inline-block col-sm-4 py-sm-2 p-sm-0 col-print-7 
                                            d-md-inline-block col-md-4 py-md-2 p-md-0 d-lg-inline-block col-lg-4 py-lg-2 p-lg-0">
                                    <div class="text-secondary format-compacta">ESTADO CIVIL:</div>
                                    <div class="text-uppercase format-compacta">{{ r?.estadoCivil || msgNull }}</div>
                                </div>
                                <div class="d-flex justify-content-between p-0 col-12 d-sm-inline-block col-sm-4 py-sm-2 p-sm-0 col-print-7 
                                            d-md-inline-block col-md-4 py-md-2 p-md-0 d-lg-inline-block col-lg-4 py-lg-2 p-lg-0">
                                    <div class="text-secondary format-compacta">NACIONALIDADE:</div>
                                    <div class="text-uppercase format-compacta">{{ r?.nacionalidade || msgNull }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngFor="let r of consulta.registros; let i = index">
                <h2 class="subtitle"> 
                    {{i+1}} - {{ r.razao_social ? r.razao_social : 'SÓCIO' }}
                </h2>
                <div class="row col-12 px-0">
                    <ul class="card-list-striped py-0">
                        <li>
                            <span class="text-secondary">DOCUMENTO:</span>
                            <span class="text-uppercase">{{ r.documento || msgNull }}</span>
                        </li>
                        <li>
                            <span class="text-secondary">NOME:</span>
                            <span class="text-uppercase">{{ r.razao_social || msgNull }}</span>
                        </li>
                        <li>
                            <span class="text-secondary">SITUAÇÃO:</span>
                            <span class="text-uppercase">{{ r.situacao_documento || msgNull }}</span>
                        </li>
                        <li>
                            <span class="text-secondary">NACIONALIDADE:</span>
                            <span class="text-uppercase">{{ r.nacionalidade || msgNull }}</span>
                        </li>
                        <li>
                            <span class="text-secondary">CARGO:</span>
                            <span class="text-uppercase">{{ r.cargo_direcao || msgNull }}</span>
                        </li>
                        <li>
                            <span class="text-secondary">CARGO ADMINISTRAÇÃO:</span>
                            <span class="text-uppercase">{{ r.cargo_administracao || msgNull }}</span>
                        </li>
                        <li>
                            <span class="text-secondary">RELACIONAMENTO:</span>
                            <span class="text-uppercase">{{ r.tipo_relacionamento || msgNull }}</span>
                        </li>
                        <li>
                            <span class="text-secondary">PARTICIPAÇÃO:</span>
                            <span class="text-uppercase">{{ r.participacao || msgNull }}</span>
                        </li>
                        <li>
                            <span class="text-secondary">ENTRADA:</span>
                            <span class="text-uppercase">{{ r.data_entrada || msgNull }}</span>
                        </li>
                        <li>
                            <span class="text-secondary">SAÍDA:</span>
                            <span class="text-uppercase">{{ r.data_saida || msgNull }}</span>
                        </li>
                    </ul>
                </div>
            </ng-container>
        </div>
    </ng-container>
</app-card-consulta>